import UnidadeMedida from '@/spa/unidade-medida/UnidadeMedidaCadastro';

export default {
  path: 'unidade-medida',
  name: 'unidade-medida',
  component: UnidadeMedida,
};
